import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const containerStyle = { maxWidth: 1000, margin: '40px auto', padding: 24, border: '1px solid #ddd', borderRadius: 10, background: '#fafafa' };
const btnSecondary = { padding: '10px 16px', background: '#6c757d', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', marginRight: 8 };
const btnDanger = { padding: '6px 12px', background: '#dc3545', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' };
const btnInfo = { padding: '6px 12px', background: '#17a2b8', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', marginRight: 8 };

const subjectColors = {
  english: { bg: '#007BFF', text: '#fff' },
  math: { bg: '#28a745', text: '#fff' },
  science: { bg: '#6f42c1', text: '#fff' }
};

const API_BASE = '/api';

export default function ViewExams() {
  const navigate = useNavigate();
  const [exams, setExams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => { fetchExams(); }, []);

  const fetchExams = async () => {
    setLoading(true); setError('');
    try {
      const res = await fetch(`${API_BASE}/admin/exams`);
      if (!res.ok) throw new Error('Failed to fetch exams');
      setExams(await res.json());
    } catch (err) { setError(err.message); } finally { setLoading(false); }
  };

  const handleDelete = async (id, examName) => {
    if (!window.confirm(`Delete exam "${examName}"? This cannot be undone.`)) return;
    try {
      const res = await fetch(`${API_BASE}/admin/exams/${id}`, { method: 'DELETE' });
      if (!res.ok) throw new Error('Delete failed');
      setExams(prev => prev.filter(e => e.id !== id));
    } catch (err) { setError(err.message); }
  };

  const formatDate = (d) => new Date(d).toLocaleDateString('en-US', {
    year: 'numeric', month: 'short', day: 'numeric'
  });

  return (
    <div style={containerStyle}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h2 style={{ margin: 0 }}>Saved Exams</h2>
        <button onClick={() => navigate('/admin/dashboard')} style={btnSecondary}>← Back</button>
      </div>

      {error && <div style={{ padding: 10, background: '#f8d7da', color: '#721c24', borderRadius: 6, marginBottom: 15 }}>{error}</div>}

      {/* Table Header */}
      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1.5fr 1.8fr', gap: 10, padding: '10px 15px', background: '#e9ecef', borderRadius: '8px 8px 0 0', fontWeight: 600, fontSize: 14 }}>
        <div>Exam Name</div>
        <div>Subject</div>
        <div>Questions</div>
        <div>Created</div>
        <div>Actions</div>
      </div>

      {loading && <p style={{ textAlign: 'center', padding: 20 }}>Loading exams...</p>}
      
      {!loading && exams.length === 0 && (
        <p style={{ textAlign: 'center', padding: 20, color: '#666' }}>
          No exams found. <button onClick={() => navigate('/admin/exam-builder')} style={{ ...btnInfo, padding: '4px 8px', fontSize: 13 }}>Create one</button>
        </p>
      )}

      {/* Exam List */}
      {!loading && exams.map(exam => {
        const colors = subjectColors[exam.exam_topic] || { bg: '#6c757d', text: '#fff' };
        return (
          <div key={exam.id} style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1.5fr 1.8fr', gap: 10, padding: '12px 15px', background: '#fff', borderBottom: '1px solid #eee', alignItems: 'center' }}>
            <div style={{ fontWeight: 500 }}>{exam.exam_name}</div>
            <div>
              <span style={{ 
                padding: '3px 10px', 
                background: colors.bg, 
                color: colors.text, 
                borderRadius: 12, 
                fontSize: 11, 
                fontWeight: 600,
                textTransform: 'capitalize'
              }}>
                {exam.exam_topic}
              </span>
            </div>
            <div style={{ textAlign: 'center', fontWeight: 500 }}>{exam.question_count || 0}</div>
            <div style={{ fontSize: 13, color: '#666' }}>{formatDate(exam.created_at)}</div>
            <div style={{ display: 'flex', gap: 8 }}>
              <button 
                onClick={() => navigate(`/admin/exam-preview/${exam.id}`)} 
                style={{ ...btnInfo, padding: '6px 12px', fontSize: 13 }}
              >
                View
              </button>
              <button 
                onClick={() => handleDelete(exam.id, exam.exam_name)} 
                style={{ ...btnDanger, padding: '6px 12px', fontSize: 13 }}
              >
                Delete
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}